import {
    setAppBackgroundColor,
    type AppBackgroundColor,
} from "@/utils/set-site-bg-color";
export interface Input extends Marko.HTMLAttributes<HTMLDivElement> {
    color: AppBackgroundColor;
}

<div/containerRef>
    <${input.content}/>
</div>

<script>
    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                setAppBackgroundColor(input.color);
            }
        },
        {
            rootMargin: "-50% 0% -50% 0%",
        },
    );
    observer.observe(containerRef());
    $signal.onabort = () => {
        observer.unobserve(containerRef());
        observer.disconnect();
    };
</script>
